import urls from '../constants/urls';

import { ADD_ERROR_FLASH, removeFlash } from './flashes';
import { gatherErrors } from '../utils/errorHandling';

export const PASSWORD_RESET_FAILED = 'passwordResets/PASSWORD_RESET_FAILED';
export const PASSWORD_RESET_SUCCESS = 'passwordResets/PASSWORD_RESET_SUCCESS';
export const RESETTING_PASSWORD = 'passwordResets/RESETTING_PASSWORD';

export const PASSWORD_RESET_REQUEST_FAILED =
  'passwordResets/PASSWORD_RESET_REQUEST_FAILED';
export const PASSWORD_RESET_FOR_USER_SUCCESS =
  'passwordResets/PASSWORD_RESET_FOR_USER_SUCCESS';
export const PASSWORD_RESET_REQUEST_SUCCESS =
  'passwordResets/PASSWORD_RESET_REQUEST_SUCCESS';
export const REQUESTING_PASSWORD_RESET =
  'passwordResets/REQUESTING_PASSWORD_RESET';

const initialState = {
  failedConfirmation: false,
  failedRequest: false,
  resetErrors: {},

  isConfirming: false,
  isRequesting: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RESETTING_PASSWORD:
      return {
        ...state,
        failedConfirmation: false,
        isConfirming: true,
      };

    case PASSWORD_RESET_SUCCESS:
      return {
        ...state,
        isConfirming: false,
      };

    case PASSWORD_RESET_FAILED:
      return {
        ...state,
        failedConfirmation: true,
        isConfirming: false,
        resetErrors: gatherErrors(action.error, 'reset_password_failed'),
      };

    case REQUESTING_PASSWORD_RESET:
      return {
        ...state,
        failedRequest: false,
        isRequesting: true,
      };

    case PASSWORD_RESET_FOR_USER_SUCCESS:
    case PASSWORD_RESET_REQUEST_SUCCESS:
      return {
        ...state,
        isRequesting: false,
      };

    case PASSWORD_RESET_REQUEST_FAILED:
      return {
        ...state,
        failedRequest: true,
        isRequesting: false,
      };

    default:
      return state;
  }
};

export const resetPasswordFailed = resp => dispatch => {
  const errors = resp.error.response.data['errors'];
  const errorMsg = (errors[0] || {}).title;

  if (typeof errorMsg !== 'undefined') {
    dispatch({
      type: ADD_ERROR_FLASH,
      flashMessage: errorMsg,
    });

    removeFlash('errors', errorMsg, dispatch);
  }
};

export const resetPassword = (passwordResetToken, params) => dispatch => {
  return dispatch({
    types: [RESETTING_PASSWORD, PASSWORD_RESET_SUCCESS, PASSWORD_RESET_FAILED],
    payload: {
      request: {
        method: 'patch',
        url: urls.passwordResets.reset(passwordResetToken),
        data: {
          user: {
            password: params.password,
            password_confirmation: params.password_confirmation,
          },
        },
      },
    },
  });
};

export const requestPasswordResetToken = (
  params,
  onBehalfOfUser = false
) => dispatch => {
  let successType = onBehalfOfUser
    ? PASSWORD_RESET_FOR_USER_SUCCESS
    : PASSWORD_RESET_REQUEST_SUCCESS;

  return dispatch({
    types: [
      REQUESTING_PASSWORD_RESET,
      successType,
      PASSWORD_RESET_REQUEST_FAILED,
    ],
    payload: {
      request: {
        method: 'post',
        url: urls.passwordResets.request,
        data: { email: params.email },
      },
    },
  });
};

export const requestAuthEmailToMyself = (
  params,
  onBehalfOfUser = false
) => dispatch => {
  let successType = onBehalfOfUser
    ? PASSWORD_RESET_FOR_USER_SUCCESS
    : PASSWORD_RESET_REQUEST_SUCCESS;

  return dispatch({
    types: [
      REQUESTING_PASSWORD_RESET,
      successType,
      PASSWORD_RESET_REQUEST_FAILED,
    ],
    payload: {
      request: {
        method: 'post',
        url: urls.authEmail.create(params.userId, params.type)
      },
    },
  });
};
